import GameManager from '../../../../core/GameManager';
import BleedingControlScenario, { ScenarioEndType, ScenarioSceneType, StepToSkip } from '../../../../misc/BleedingControlScenario';
import { constants } from '../../../../misc/helpers';
import mainTestScenarioStep1 from './MainTestScenarioStep1';
import mainTestScenarioStep2 from './MainTestScenarioStep2';
import mainTestScenarioSteps12 from './MainTestScenarioSteps12';
import mainTestScenarioSteps13And14And15 from './MainTestScenarioSteps13And14And15';
import mainTestScenarioSteps3And4 from './MainTestScenarioSteps3And4';
import mainTestScenarioSteps5And6 from './MainTestScenarioSteps5And6';
import mainTestScenarioSteps7And8 from './MainTestScenarioSteps7And8';
import mainTestScenarioSteps9And10And11 from './MainTestScenarioSteps9And10And11';
import mainTestScenarioEnd from './MainTestScenarioEnd';
import TourniquetePlacement from '../../../../components/uiElements/unityIntegration/TourniquetePlacement';
import { customRouter } from '../../../../CustomRouter';

export default class MainTestScenario extends BleedingControlScenario {
	firstTourniqueteApplied: boolean = false;
	
	constructor(gameManager: GameManager, scenarioName: string, scenarioSceneToLoad: ScenarioSceneType,
		public endAt: ScenarioEndType, stepsToSkip?: StepToSkip[], isSufficient?: boolean, shownPercentage?: number, shownPercentage2?: number, locations?: any[], locations2?: any[], correctT1?: number, correctT2?: number, wrongT1?: number, closeT1?: number, 
		SceneAT?: boolean, SceneBT?: boolean, SceneCT?: boolean, SceneDT?: boolean, startTitle?: string, startTitleText?: string) {
		super(gameManager, scenarioName, scenarioSceneToLoad, endAt, stepsToSkip, isSufficient, shownPercentage, shownPercentage2);
		this.locations = locations;
		this.locations2 = locations2;
		this.correctT1 = correctT1;
		this.correctT2 = correctT2;
		this.wrongT1 = wrongT1;
		this.closeT1 = closeT1;
		this.SceneAT = SceneAT;
		this.SceneBT = SceneBT;
		this.SceneCT = SceneCT;
		this.SceneDT = SceneDT;
		this.startTitle = startTitle;
		this.startTitleText = startTitleText;
	}
	public locations: any = [];
	public locations2: any = [];
	public correctT1: number;
	public correctT2: number;
	public wrongT1: number;
	public closeT1: number;
	public SceneAT: boolean;
	public SceneBT: boolean;
	public SceneCT: boolean;
	public SceneDT: boolean;
	public startTitle: string = '';
	public startTitleText: string = '';

	public soundFolderAndPath(section: string, part: string): string {
		throw new Error('soundFolderAndPath needs to be implemented in child class')
	}

	public skipBCK: boolean = false;
	public stepsOrder1: boolean = false;
	public stepsOrder2: boolean = false;
	public stepsOrder3: boolean = false;
	public stepsOrder5: boolean = false;
	public stepsOrder7: boolean = false;
	public stepsOrder9: boolean = false;
	public stepsOrder12: boolean = false;
	public stepsOrder13: boolean = false;
	public steps1Done: boolean = false;
	public steps2Done: boolean = false;
	public steps3Done: boolean = false;
	public steps5Done: boolean = false;
	public steps7Done: boolean = false;
	public steps9Done: boolean = false;
	public steps12Done: boolean = false;
	public steps13Done: boolean = false;
	public step3Skipped: boolean = false;
	public incorrectPathChosen: boolean = false;

	public selectedTourniquetIndex = 0;
	public moveToTourniquetLocation() {
		this.playSequence('TorniqueteLocation' + this.selectedTourniquetIndex);
	}
	start() {
		this.goToStep0();
	}

	goToStep0() {
		var context = this;
		switch(this.scenarioSceneToLoad) {
			case ScenarioSceneType.scenarioA:
				context.loadParkingGarageScene('scenarioa', () => context.goToStep1());
				break;
			case ScenarioSceneType.scenarioB:
				context.loadOutsideVAScene('scenariob', () => context.goToStep1());
				break;
			case ScenarioSceneType.scenarioC:
				context.loadLobbyVAScene('scenarioc', () => context.goToStep1());
				break;
			case ScenarioSceneType.scenarioD:
				context.loadOutsideVAScene('scenariod', () => context.goToStep1());
				break;

		}
	}

	goToStep1() {
		var context = this;
		if(this.stepsOrder2 === false && this.stepsOrder3 === false && this.stepsOrder5 === false && this.stepsOrder7 === false && this.stepsOrder9 === false && this.stepsOrder12 === false && this.stepsOrder13 === false) {
			context.stepsOrder1 = true;
		}
		else{
			context.stepsOrder1 = false;
		}

		new mainTestScenarioStep1(this, (aarReady1) => {
			if(aarReady1 === true) {
				context.steps1Done = true;
			}
			else if(aarReady1 === false) {
				context.steps1Done = false;
			}
		context.goToStep2()},
		 () => context.goToFailedScenario(), context.startTitle, context.startTitleText).start();
	}

	goToStep2() {
		var context = this;
		if(this.steps1Done === true && this.steps3Done === false && this.steps5Done === false && this.steps7Done === false && this.steps9Done === false && this.steps12Done === false && this.steps13Done === false) {
			context.stepsOrder2 = true;
		}
		else {context.stepsOrder2 = false};

		new mainTestScenarioStep2(this, (selectedIndex, aarReady2) => { 
			if(aarReady2 === true) {
				context.steps2Done = true;
			}
			else if(aarReady2 === false) {
				context.steps2Done = false;
			}
			if(selectedIndex === -1) {
				if(this.stepsToSkip && this.stepsToSkip.indexOf(StepToSkip.steps3And4And5And6) !== -1) {
					if(context.firstTourniqueteApplied === true) {
						context.skipBCK = false;
						context.goToSteps12();
					}
					else {
						context.skipBCK = false;
						context.goToSteps7And8();
					}
				} else {
					context.skipBCK = false;
					context.goToSteps3And4();
				}
			} 
			else if(selectedIndex === -2) {
				context.skipBCK = true;
				context.goToSteps3And4();
			}
			else if(selectedIndex === -3) {
				if(context.firstTourniqueteApplied === true) {
					context.skipBCK = true;
					context.goToSteps12();
				}
				else {
					context.skipBCK = true;
					context.goToSteps7And8();
				}
			}
			else {
				context.determineWhereToGoForBCK(selectedIndex);
			}
		 }, () => context.goToFailedScenario()).start();
	}

	goToSteps3And4() {
		var context = this;
		if(this.steps1Done === true && this.steps2Done === true && this.steps5Done === false && this.steps7Done === false && this.steps9Done === false && this.steps12Done === false && this.steps13Done === false) {
			context.stepsOrder3 = true;
		}
		else {context.stepsOrder3 = false};

		new mainTestScenarioSteps3And4(this, (selectedIndex, aarReady3) => { 
			if(aarReady3 === true) {
				context.steps3Done = true;
			}
			else if(aarReady3 === false) {
				context.steps3Done = false;
			}
			if(selectedIndex === -1) {
				context.skipBCK = false;
				context.goToSteps5And6(); 
			} 
			else if(selectedIndex === -2) {
				context.skipBCK = true;
				context.goToStep2();
			}
			else if(selectedIndex === -3) { 
				if(context.firstTourniqueteApplied === true) {
					context.skipBCK = true;
					context.goToSteps12();
				}
				else {
					context.skipBCK = true;
					context.goToSteps7And8();
				}
			}
			else {
				this.determineWhereToGoForBCK(selectedIndex);
			}
		}, () => context.goToFailedScenario()).start();
	}

	goToSteps5And6() {
		var context = this;
		if(this.steps1Done === true && this.steps2Done === true && this.steps3Done === true && this.steps7Done === false && this.steps9Done === false && this.steps12Done === false && this.steps13Done === false) {
			context.stepsOrder5 = true;
		}
		else {context.stepsOrder5 = false};

		new mainTestScenarioSteps5And6(this, (aarReady5) => { 
			if(aarReady5 === true) {
				context.steps5Done = true;
			}
			else if(aarReady5 === false) {
				context.steps5Done = false;
			}
			if(this.endAt === ScenarioEndType.pressureDressing) {
				if(this.stepsOrder5 === true && this.steps5Done === true) {
					context.goToScenarioEnd(); 
				}
				else {
					context.goToFailedScenario(); 
				}
			} 
			else {
				if(context.firstTourniqueteApplied === true) {
					context.goToSteps12();
				}
				else {
					context.goToSteps7And8();
				}
			}
		}, () => context.goToFailedScenario()).start();
	}

	goToSteps7And8() {
		var context = this;
		if(this.stepsToSkip && this.stepsToSkip.indexOf(StepToSkip.steps3And4And5And6) !== -1) {
			if(this.steps1Done === true && this.steps2Done === true && this.steps3Done === false && this.steps5Done === false && this.steps9Done === false && this.steps12Done === false && this.steps13Done === false) {
				context.stepsOrder7 = true;
				}
				else {context.stepsOrder7 = false};
		}
		else {
			if(this.steps1Done === true && this.steps2Done === true && this.steps3Done === true && this.steps5Done === true && this.steps9Done === false && this.steps12Done === false && this.steps13Done === false) {
			context.stepsOrder7 = true;
			}
			else {context.stepsOrder7 = false};
		}

		new mainTestScenarioSteps7And8(this, (selectedIndex, aarReady7) => {
			if(aarReady7 === true) {
				context.steps7Done = true;
			}
			else if(aarReady7 === false) {
				context.steps7Done = false;
			}
			if(selectedIndex === -1) {
				context.skipBCK = false;
				context.firstTourniqueteApplied = true;
				context.goToSteps9And10And11(); 
			} 
			else if(selectedIndex === -2) {
				context.skipBCK = true;
				context.goToStep2();
			}
			else if(selectedIndex === -3) {
				context.skipBCK = true;
				context.goToSteps3And4();
			}
			else {
				context.determineWhereToGoForBCK(selectedIndex);
			}
		}, () => context.goToFailedScenario()).start();
	}

	goToSteps9And10And11() {
		var context = this;
		if(this.stepsToSkip && this.stepsToSkip.indexOf(StepToSkip.steps3And4And5And6) !== -1) {
			if(this.steps1Done === true && this.steps2Done === true && this.steps7Done === true && this.steps3Done === false && this.steps5Done === false && this.steps12Done === false && this.steps13Done === false) {
				context.stepsOrder9 = true;
				}
				else {context.stepsOrder9 = false};
		}
		else {
			if(this.steps1Done === true && this.steps2Done === true && this.steps3Done === true && this.steps5Done === true && this.steps7Done === true && this.steps12Done === false && this.steps13Done === false) {
			context.stepsOrder9 = true;
			}
			else {context.stepsOrder9 = false};
		}

		new mainTestScenarioSteps9And10And11(this, (aarReady9) => { 
			if(aarReady9 === true) {
				context.steps9Done = true;
			}
			else if(aarReady9 === false) {
				context.steps9Done = false;
			}
			if(this.endAt === ScenarioEndType.firstTourniquete) {
				if(this.stepsOrder9 === true && this.steps9Done === true) {
					context.goToScenarioEnd(); 
				}
				else {
					context.goToFailedScenario(); 
				}
			} 
			else if(this.endAt === ScenarioEndType.pressureDressing) {
					context.goToFailedScenario(); 
			} 
			else {
				context.goToSteps12(); 
			}
		}, () => context.goToFailedScenario()).start();
	}

	goToSteps12() {
		var context = this;
		if(this.stepsToSkip && this.stepsToSkip.indexOf(StepToSkip.steps3And4And5And6) !== -1) {
			if(this.steps1Done === true && this.steps2Done === true && this.steps7Done === true && this.steps9Done === true && this.steps3Done === false && this.steps5Done === false && this.steps13Done === false) {
				context.stepsOrder12 = true;
				}
				else {context.stepsOrder12 = false};
		}
		else {
			if(this.steps1Done === true && this.steps2Done === true && this.steps3Done === true && this.steps5Done === true && this.steps7Done === true && this.steps9Done === true && this.steps13Done === false) {
			context.stepsOrder12 = true;
			}
			else {context.stepsOrder12 = false};
		}

		new mainTestScenarioSteps12(this, (selectedIndex, aarReady12) => { 
			if(aarReady12 === true) {
				context.steps12Done = true;
			}
			else if(aarReady12 === false) {
				context.steps12Done = false;
			}
			if(selectedIndex === -1) {
				context.skipBCK = false;
				context.goToSteps13And14And15(); 
			} 
			else if(selectedIndex === -2) {
				context.skipBCK = true;
				context.goToStep2();
			}
			else if(selectedIndex === -3) {
				context.skipBCK = true;
				context.goToSteps3And4();
			}
			else {
				context.determineWhereToGoForBCK(selectedIndex);
			}
		}, () => context.goToFailedScenario()).start();
	}

	goToSteps13And14And15() {
		var context = this;
		if(this.stepsToSkip && this.stepsToSkip.indexOf(StepToSkip.steps3And4And5And6) !== -1) {
			if(this.steps1Done === true && this.steps2Done === true && this.steps7Done === true && this.steps3Done === false && this.steps5Done === false  && this.steps9Done === true && this.steps12Done === true) {
				context.stepsOrder13 = true;
				}
				else {context.stepsOrder13 = false};
		}
		else {
			if(this.steps1Done === true && this.steps2Done === true && this.steps3Done === true && this.steps5Done === true && this.steps7Done === true  && this.steps9Done === true && this.steps12Done === true) {
			context.stepsOrder13 = true;
			}
			else {context.stepsOrder13 = false};
		}

		new mainTestScenarioSteps13And14And15(this, (aarReady13) => {
			if(aarReady13 === true) {
				context.steps13Done = true;
			}
			else if(aarReady13 === false) {
				context.steps13Done = false;
			}
			if(this.stepsOrder13 === true && this.steps13Done === true) {
				context.goToScenarioEnd(); 
			}
			else {
				context.goToFailedScenario(); 
			}
			}, () => context.goToFailedScenario()).start();
	}

	goToScenarioEnd() {
		var context = this;
		this.aarPassed = true;
		new mainTestScenarioEnd(this, () => { 
			//TODO: go back to main menu
			context.setScenarioPassed(true);
			context.endScenario();
		}).start();
	}

	goToFailedScenario() {
		var context = this;
		this.aarPassed = false;
		new mainTestScenarioEnd(this, () => { 
			//TODO: go back to main menu
			context.setScenarioPassed(false);
			context.endScenario();
		}).start();
	}

	determineWhereToGoForBCK(indx: number) {
		switch(indx) {
			case 0:
				this.goToSteps3And4();
				break;
			case 1:
				if(this.firstTourniqueteApplied) {
					this.goToSteps12();
				} else {
					this.goToSteps7And8();
				}
				break;
			case 2:
				this.goToStep2();
				break;
		}
	}

	public showMainMenu() {
		var url = new URL(window.location.href);
		var search_params = url.searchParams;
		
		search_params.set('w', '0');

		url.search = search_params.toString();

		window.location.href = url.toString();
		//customRouter.routeTo(process.env.PUBLIC_URL);
		//window.location.href = process.env.PUBLIC_URL
	}

}